<template>
<div class="chapter">
<div class="inner_page">
<a id="page_v"></a>
<h1 class="toc-title">Contents</h1>
<h2 class="toc"><a href="#/xhtml/04_Preface">Preface</a></h2>
<h2 class="toc"><a href="#/xhtml/05_Acknowledgements">Acknowledgements</a></h2>
<h2 class="toc"><a href="#/xhtml/06_Abbreviations">Abbreviations</a></h2>
<h2 class="toct"><a href="#/xhtml/07_Introduction">Introduction: Conspiracy Thinking</a></h2>
<h2 class="tocp"><a href="#/xhtml/08_Part01">Part I JFK</a></h2>
<h3 class="tocc"><a href="#/xhtml/09_Chapter01">1. Who Killed JFK?</a></h3>
<h3 class="tocc"><span href="#/xhtml/10_Chapter02" title="Link target outside of Sample">2. The Rosetta Stone – The Life of Lee Harvey Oswald</span></h3>
<h3 class="tocc"><span href="#/xhtml/11_Chapter03" title="Link target outside of Sample">3. Jack Ruby and the Mafia</span></h3>
<h3 class="tocc"><span href="#/xhtml/12_Chapter04" title="Link target outside of Sample">4. The Alleged CIA Conspiracy</span></h3>
<h3 class="tocc"><span href="#/xhtml/13_Chapter05" title="Link target outside of Sample">5. Did Castro Kill JFK?</span></h3>
<h2 class="tocp"><span href="#/xhtml/14_Part02" title="Link target outside of Sample">Part II RFK</span></h2>
<h3 class="tocc"><span href="#/xhtml/15_Chapter06" title="Link target outside of Sample">6. Sirhan’s Motives</span></h3>
<h3 class="tocc"><span href="#/xhtml/16_Chapter07" title="Link target outside of Sample">7. Did the CIA Assassinate Robert F. Kennedy?</span></h3>
<h3 class="tocc"><span href="#/xhtml/17_Chapter08" title="Link target outside of Sample">8. Hypnotized Assassin?</span></h3>
<h3 class="tocc"><span href="#/xhtml/18_Chapter09" title="Link target outside of Sample">9. The ‘Mystery’ of the Polka-Dot Girl</span></h3>
<h3 class="tocca"><span href="#/xhtml/19_Chapter10" title="Link target outside of Sample">10. The Myths of the RFK Assassination</span></h3>
<h3 class="tocca"><span href="#/xhtml/20_Chapter11" title="Link target outside of Sample">11. Case Closed</span></h3>
<h2 class="toct"><span href="#/xhtml/21_Notes" title="Link target outside of Sample">Notes</span></h2>
<h2 class="toc"><span href="#/xhtml/22_Bibliography" title="Link target outside of Sample">Bibliography</span><a id="page_vi"></a></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?1f24dace